import React from 'react';
import { Logo } from 'components/Logo';
import { Footers } from 'components/Footer';
import LogoImage from 'assets/images/logo-with-down-text.svg';
import { FooterMenu } from './FooterMenu';

const Footer = () => (
  <Footers
    logo={<Logo withLink linkTo="/" src={LogoImage} title="Logo" />}
    menu={<FooterMenu />}
    copyright={`Copyright @anto.info ${new Date().getFullYear()}`}
  />
);

export default Footer;
